import { render, staticRenderFns } from "./OpportunitiesPublishedNumber.vue?vue&type=template&id=6345c89a"
import script from "./OpportunitiesPublishedNumber.vue?vue&type=script&lang=ts"
export * from "./OpportunitiesPublishedNumber.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports